import locale from './locale';

export default (name)=>{
  const msgs = {
    "required": __('This field is required', locale),
    "invalid_email": __('Please enter a valid email', locale),
    "invalid_phone": __('Please enter a valid phone number', locale),
  }

  return msgs[name];
}



// WEBPACK FOOTER //
// ./src/components/Form/getDefaultErrorMessages.js